module.exports = __webpack_public_path__ + "static/media/Holdings-screen@2x.febad33e.png";